// extracted by mini-css-extract-plugin
module.exports = {"benefitsSection":"_2DW1O","section":"_3Snq_"};